import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'


import { chainDecorators, memoized } from '../../utils/ReactUtils'

import ReviewSlide from '../ReviewSlide'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper'

import 'swiper/swiper.min.css'
import 'swiper/modules/pagination/pagination.min.css'


import styles from './styles'


const decorators = [
  memoized,
]

function SliderReviews({ className, reviews }) {
  return (
    <div className={classnames('slider', className)}>
      <div className="swiper">
        <Swiper
          modules={[Navigation]}
          slidesPerView={1}
          navigation={{ prevEl: '.button-prev',nextEl: '.button-next' }}
          loop
          autoHeight
        >
          {reviews.map((review, index) => <SwiperSlide key={`review-${index}`}>
            <ReviewSlide  {...review} />
          </SwiperSlide>)}
          <div className="arrows">
            <button role={'button'} aria-label={'previous'} className='button-prev'><img width={22} height={22} src={'/images/icons/arrow-left-white.svg'} alt={'arrow-left'} /></button>
            <button role={'button'} aria-label={'next'} className='button-next'><img width={22} height={22} src={'/images/icons/arrow-right-white.svg'} alt={'arrow-right'} /></button>
          </div>
        </Swiper>
      </div>
      <style jsx>{styles}</style>
    </div>
  )
}

SliderReviews.propTypes = {
  className: PropTypes.string,
  slides: PropTypes.arrayOf(PropTypes.shape(ReviewSlide.propTypes)).isRequired
}

SliderReviews.defaultProps = {
  className: null,
  slides: []
}

SliderReviews = chainDecorators(decorators, SliderReviews)

export default SliderReviews
